export const fonts = {
  families: ["Poppins:wght@200;300;400;500;600;700"],
  poppins: "font-family: 'Poppins', sans-serif;",
  arial: "font-family: Arial, sans-serif;",
};
